import { ExportReq, HttpService } from "@/core";
import { ExportResp, Records } from "@/core/interface";
import { CompanyContactService } from "@/views/cooperation/company/company-contact.service";
import {
  ContractPageReq,
  ContractPageResp,
  ContractDetailResp,
  ContractReq,
  DetailRecord,
  ContractSimpleRecord,
} from "./contract.interface";

export class ContractService {
  static usePageApi() {
    const api = (params: ContractPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_contract/page",
        params,
      });
    return HttpService.usePagination<ContractPageResp>(api);
  }

  static useSimpleListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/purchase_contract/simple/list",
        params,
      });
    return HttpService.useRequest<Records<ContractSimpleRecord>>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/purchase_contract/${id}`,
      });
    return HttpService.useRequest<ContractDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: ContractReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_contract",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useEditApi() {
    const api = (id: string, data: ContractReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/purchase_contract/${id}`,
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/purchase_contract/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_contract/export",
        data: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useDetailExportApi() {
    const api = (id: string, titleParamReqs: any) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_contract/export/new/detail",
        data: { ids: [id], titleParamReqs: titleParamReqs },
      });
    return HttpService.useRequest<ExportResp>(api, { isOutError: true });
  }

  static async fetchCompanyFields(companyId: string) {
    const result = {
      supplierContacts: "",
      supplierMobile: "",
    };
    const { run } = CompanyContactService.useListApi();
    const res = await run(companyId);
    if (res.respCode === "0000") {
      if (res.data?.records && res.data.records.length) {
        const firstContact = res.data.records[0];
        result.supplierContacts = firstContact.name;
        result.supplierMobile = firstContact.mobile;
      }
    }
    return result;
  }

  static validAloneDetail(list: DetailRecord[] = []) {
    if (list.length === 0) {
      return false;
    }
    let valid = true;
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if (!item.count || (item.taxPrice === null || item.taxPrice === undefined)) {
        valid = false;
        break;
      }
    }
    return valid;
  }

  static validFrameDetail(list: DetailRecord[] = []) {
    if (list.length === 0) {
      return false;
    }
    let valid = true;
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if (item.taxPrice === null || item.taxPrice === undefined) {
        valid = false;
        break;
      }
    }
    return valid;
  }
  static contractAddNew() {
    const api = (data: ContractReq) =>
      HttpService.axios({
        method: "POST",
        url: "/purchase_contract/add_new",
        data,
      });
    return HttpService.useRequest<{ id: string }>(api);
  }
}
